module.exports = __webpack_public_path__ + "img/Romantikken_Casper-David-Friedrich.ace2e668.jpg";